export interface FeaturesEnabledRequest {
  type: FeaturesEnabledType;
  search?: string;
}

interface FeaturesEnabledDto {
  clientId: string;
  clientName: string;
  siteUrl: string;
  enabledFeatures: string[];
}

export interface FeaturesEnabledResponse {
  lastUpdated: string;
  clients: FeaturesEnabledDto[];
  features: string[];
}

export enum FeaturesEnabledType {
  SearchStatic = "SearchStatic",
  SearchFloat = "SearchFloat",
  SearchMap = "SearchMap",
  SiteFeatures = "SiteFeatures",
  Integrations = "Integrations",
}
